import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import useVehicleRegistrationFormData from '../../dealer-vehicle-registration-form/hook/useVehicleRegistrationFormData';
import FormVehicleRegistrationForm from './component/FormVehicleRegistrationForm';
import VehicleRegistrationDocumentManager from './component/VehicleRegistrationDocumentManager';

import { useGetDocumentsByVehicleRegistrationFormIdQuery } from '../../../../../api';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const VehicleRegistrationFormCreateEdit = () => {
    const { id } = useParams();
    const { th } = useLanguage();
    const initialState = {
        chassisNo: '', 
        vehiclePlate: '',
        kmInformation: 0,
        vehicleRegistration: '',
        returnMsg: '',
        customerName: '',
        nameCompany: '',
        customerPhone: '',
        customerEmail: '',
        customerAddress: '',
        customerStreet: '',
        customerHome: '',
        customerCity: '',
        customerPostalCode: '',
        customerCountry: ''
    };

    const { saveVehicleRegistrationForm, uploadVehicleRegistrationDocument, updateVehicleRegistrationDocument, deleteVehicleRegistrationDocument, CVRFStatus, isDeleting, isUpdatingDocument, isUploading } = useVehicleRegistrationFormData();
    const [formData, setFormData] = useState(initialState);
    const [submitted, setSubmitted] = useState(false);

    const { data: documentList = [], isLoading: isLoadingDocuments } = useGetDocumentsByVehicleRegistrationFormIdQuery(id, { skip: !id });

    const resetForm = useCallback(() => {
        setFormData(initialState);
        setSubmitted(false);
    }, []);

    const handleChange = useCallback((key, value) => {
        setFormData((prev) => ({
            ...prev,
            [key]: value
        }));
    }, []);

    return (
        <>
            <div className="card">
                <h2>{id ? th('warranty.dealerVehicleRegistrationForm.form.editTitle') : th('warranty.dealerVehicleRegistrationForm.form.addTitle')}</h2>
                <FormVehicleRegistrationForm
                    editMode={!!id}
                    id={id}
                    submitted={submitted}
                    formData={formData}
                    handleChange={handleChange}
                    setFormData={setFormData}
                    saveVehicleRegistrationForm={saveVehicleRegistrationForm}
                    uploadVehicleRegistrationDocument={uploadVehicleRegistrationDocument}
                    resetForm={resetForm}
                    setSubmitted={setSubmitted}
                    CVRFStatus={CVRFStatus}
                />
            </div>
            {id ? (
                <div className="card">
                    <VehicleRegistrationDocumentManager
                        CVRFStatus={CVRFStatus}
                        id={id}
                        formData={formData}
                        uploadVehicleRegistrationDocument={uploadVehicleRegistrationDocument}
                        updateVehicleRegistrationDocument={updateVehicleRegistrationDocument}
                        documentList={documentList}
                        deleteVehicleRegistrationDocument={deleteVehicleRegistrationDocument}
                        isDeleting={isDeleting}
                        isUpdatingDocument={isUpdatingDocument}
                        isUploading={isUploading}
                    />
                </div>
            ) : null}
        </>
    );
};

export default VehicleRegistrationFormCreateEdit;
